/** Word-level diff of two short texts (LCS). Returns [{kind: "same"|"del"|"add", text}] – enough to show what the customer changed. */
export function diffWords(a = "", b = "") {
  const A = String(a || "").split(/(\s+)/).filter((x) => x !== "");
  const B = String(b || "").split(/(\s+)/).filter((x) => x !== "");
  if (A.length * B.length > 250_000) return [{ kind: "del", text: a }, { kind: "add", text: b }];
  const n = A.length, m = B.length;
  const dp = Array.from({ length: n + 1 }, () => new Uint16Array(m + 1));
  for (let i = n - 1; i >= 0; i -= 1) for (let j = m - 1; j >= 0; j -= 1) dp[i][j] = A[i] === B[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const out = [];
  const push = (kind, text) => { const last = out[out.length - 1]; if (last && last.kind === kind) last.text += text; else out.push({ kind, text }); };
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (A[i] === B[j]) { push("same", A[i]); i += 1; j += 1; } else if (dp[i + 1][j] >= dp[i][j + 1]) { push("del", A[i]); i += 1; } else { push("add", B[j]); j += 1; }
  }
  while (i < n) { push("del", A[i]); i += 1; }
  while (j < m) { push("add", B[j]); j += 1; }
  return out;
}
